import type { BorrowMarketAssetData } from '@/utils/internalAppSdk'
import { calculateBorrowRateAtUtilization } from './calculateBorrowRateAtUtilization'

type BorrowMarketInterestRateModel = NonNullable<BorrowMarketAssetData['interestRateModel']>

const CHART_POINTS_COUNT = 100 + 1
const MIN_CHART_MAX_RATE = 0.1

export const getBorrowInterestRateModelChartConfig = ({
  interestRateModel,
  currentBorrowRate,
}: {
  interestRateModel: BorrowMarketInterestRateModel
  currentBorrowRate?: number
}) => {
  const points = Array.from({ length: CHART_POINTS_COUNT }, (_, index) => {
    const utilizationRate = index / (CHART_POINTS_COUNT - 1)
    return {
      utilizationRate,
      borrowRate: calculateBorrowRateAtUtilization(interestRateModel, utilizationRate),
    }
  })

  const maxRate = Math.max(MIN_CHART_MAX_RATE, currentBorrowRate ?? 0, ...points.map((point) => point.borrowRate))
  const yMax = Math.ceil(maxRate * 20) / 20

  return { points, yMax }
}
